import request from './request.js';
import {requestbody} from './request.js'
//开票数据台账导入
export async function importExcel (params = {}) {
	return await request('/contract/file/upload', 'post', params)
}
//开票数据台账分页查询
export async function findPage (params = {}) {
	return await request('/contract/page', 'get', params)
}

//开票数据台账分页查询
export async function contractDel (params = {}) {
	return await request('/contract/delete', 'post', params)
}